
import React from 'react';
import { FileText, ShieldCheck } from 'lucide-react';

const LegalFooter: React.FC = () => {
  const legalUrl = 'https://hshqshiznfwasvgtcjaj.supabase.co/storage/v1/object/sign/Terminos%20y%20Condiciones/T&C%20Gym%20Bros%20v2.pdf?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV9iYzQ1ODVmNy01ZWVlLTQ0MzctYjk3Mi1lNGYyYzQ0ZjM4ZmUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJUZXJtaW5vcyB5IENvbmRpY2lvbmVzL1QmQyBHeW0gQnJvcyB2Mi5wZGYiLCJpYXQiOjE3NzI3NjI2ODgsImV4cCI6NDg5NDgyNjY4OH0.EU7YTKaxYg9BKTzUXOnTwRZ4yFF4sHm1dsSL6l9kC-E';
  const privacyUrl = legalUrl;
  const termsUrl = legalUrl;

  return (
    <footer className="mt-12 pb-8 flex flex-col items-center gap-4 opacity-40 hover:opacity-100 transition-opacity">
      <div className="flex items-center gap-6">
        <a 
          href={termsUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-[9px] font-bold uppercase tracking-[0.2em] text-white hover:text-brand transition-colors"
        >
          <FileText size={12} />
          Términos y Condiciones
        </a>
        <div className="w-1 h-1 bg-white/20 rounded-full"></div>
        <a 
          href={privacyUrl} 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-[9px] font-bold uppercase tracking-[0.2em] text-white hover:text-brand transition-colors"
        >
          <ShieldCheck size={12} />
          Políticas de Privacidad
        </a>
      </div>
      <p className="text-[8px] text-white/20 uppercase tracking-[0.3em] font-bold">
        © {new Date().getFullYear()} GymBrotherhood Elite Network
      </p>
    </footer>
  );
};

export default LegalFooter;
